import { useContext, useEffect, useRef } from "preact/hooks";
import { Recovery } from "../index";
import useStepRequest from "../Hooks/useStepRequest";

import styles from "./Confirm.module.css"

import RepeatConfirmCode from "../RepeatConfirmCode";
import Input from "../Input";
import Button from "../Button";

const PLACEHOLDERS = {
  phone: 'Введите код из SMS',
  email: 'Введите код из письма'
}

const ConfirmStep = () => {
  const {type, phone, email, setError} = useContext(Recovery)
  const { step2 } = useStepRequest()

  const confirmInput = useRef(null)

  useEffect(() => {
    if(confirmInput.current){
      confirmInput.current.focus()
    }
  }, [confirmInput])

  useEffect(() => {
    const enterListener = (event) => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        event.preventDefault();
        stepHandler()
      }
    }
    document.addEventListener('keydown', enterListener)
    return () => {
      document.removeEventListener('keydown', enterListener)
    }
  }, [])

  const CONFIRM_DESCRIPTION = {
    phone: `На номер ${phone} отправлено SMS-сообщение с кодом.`,
    email: `Введите код из электронного письма, отправленный на: ${email}`
  }

  const validConfirmCode = (code) => {
    if(!code){
      setError('Вы ничего не ввели')
      return
    }
    if(code.length < 4) {
      setError('Введите корректный проверочный код')
      return false
    }
    return true
  }

  const stepHandler = () => {
    const _code = confirmInput.current.value
    const valid = validConfirmCode(_code)
    if(valid) {
      step2(_code)
    }
  }

  const changeConfirmCode = (e) => {
    if ((!/[0-9]/.test(e.data) || e.target.value.length >= 10) && e.data) {
      e.preventDefault();
    }
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapper_description}>
        {CONFIRM_DESCRIPTION[type]}
      </div>
      <Input label='Код подтверждения' placeHolder={PLACEHOLDERS[type]} onBeforeInput={changeConfirmCode} inputRef={confirmInput} />
      <RepeatConfirmCode />
      <Button name='ПРИМЕНИТЬ' onClick={stepHandler}  />
    </div>
  );
};

export default ConfirmStep;